exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form-reset-password {\n    background-color: rgb(240, 240, 240);\n    margin: 0px auto;\n    width: 343px;\n    top: 23px;\n    position: relative;\n    height: 330px;\n}\n", ""]);

